import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useCookieStore = create(
  persist(
    (set) => ({
      // null = not decided yet, true = accepted, false = rejected
      cookieConsent: null,

      acceptCookies: () => set({ cookieConsent: true }),
      rejectCookies: () => set({ cookieConsent: false }),
    }),
    {
      name: "afrodise-cookies",
    }
  )
);